"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PonziChart = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const material_1 = require("@mui/material");
const mui_page_layout_1 = require("@dzambalaorg/mui-page-layout");
const styled_1 = require("@framework/styled");
const react_hooks_1 = require("@dzambalaorg/react-hooks");
const utils_1 = require("../../../../../utils");
const search_1 = require("./search");
const PonziChart = (props) => {
    const { service } = props;
    const { isLoading, allRows } = (0, react_hooks_1.useFetchQuery)("/ponzi/chart");
    const chartRef = (0, react_1.useRef)(null);
    const [recentDeposits, setRecentDeposits] = (0, react_1.useState)(false);
    const handleSwitchDeposit = () => {
        setRecentDeposits(value => !value);
    };
    const clearChart = (0, react_1.useCallback)(() => {
        while (chartRef.current?.lastChild) {
            chartRef.current.removeChild(chartRef.current.lastChild);
        }
    }, [chartRef.current]);
    (0, react_1.useEffect)(() => {
        if (!chartRef.current) {
            return;
        }
        if (!allRows.length) {
            clearChart();
        }
        else {
            (0, utils_1.chartCreator)(chartRef, allRows, clearChart, recentDeposits);
        }
    }, [recentDeposits, chartRef.current, allRows]);
    return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(mui_page_layout_1.Breadcrumbs, { path: ["dashboard", "ponzi", "ponzi.chart"] }), (0, jsx_runtime_1.jsx)(mui_page_layout_1.PageHeader, { message: "pages.ponzi.chart.title" }), (0, jsx_runtime_1.jsx)(search_1.PonziChartSearchForm, { service: service, recentDeposits: recentDeposits, handleSwitchDeposit: handleSwitchDeposit }), (0, jsx_runtime_1.jsx)(mui_page_layout_1.ProgressOverlay, { isLoading: isLoading, children: (0, jsx_runtime_1.jsx)(styled_1.StyledEmptyWrapper, { count: allRows.length, isLoading: isLoading, children: (0, jsx_runtime_1.jsx)(material_1.Box, { sx: { mt: 4, mb: 2 }, width: "100%", ref: chartRef }) }) })] }));
};
exports.PonziChart = PonziChart;
//# sourceMappingURL=index.js.map